/**
 * @generated SignedSource<<bdbf11a78a198bef10ae768953cd1491>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type WidgetNoteEditingMode = "DEFAULT" | "READ_ONLY";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type NoteWeb_note$data = {
  readonly editingMode: WidgetNoteEditingMode;
  readonly id: string;
  readonly isOrgNote: boolean;
  readonly noteSize: WidgetNoteSize;
  readonly pages: ReadonlyArray<{
    readonly backgroundColor: string | null;
    readonly fontColor: string | null;
    readonly id: string;
    readonly image: {
      readonly id: string;
    } | null;
    readonly includedInSlideshow: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetNotePage_widgetNotePage">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "NoteWeb_note";
};
export type NoteWeb_note$key = {
  readonly " $data"?: NoteWeb_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"NoteWeb_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NoteWeb_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrgNote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noteSize",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editingMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WidgetNotePage",
      "kind": "LinkedField",
      "name": "pages",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fontColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "includedInSlideshow",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetNotePage_widgetNotePage"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "a5602c15bfe197e5a4552db14d7ac99d";

export default node;
